import React from "react"
import { css } from "@emotion/react"
import { StaticImage } from "gatsby-plugin-image"

import AnimatedSection from "../animated-section"
import theme from "../../styles/theme"

const MaterialFlow = ({ className }) => {
  return (
    <AnimatedSection
      inverted
      className={className}
      leftElement={
        <div>
          <h2 className="dark text-sm-center">
            <em className="variant">Flux</em> matière
          </h2>
          <p className="margin-bottom-sm">
            Déjà producteur écoresponsable à la recherche de matière première ou
            nouvel entrant dans la création de valeur à base de produits
            transformables, vous êtes au bon endroit&nbsp;!
          </p>
        </div>
      }
      rightElement={
        <StaticImage
          imgStyle={{
            borderRadius: theme.shape.borderRadius[0],
            boxShadow: theme.elevation.level2,
          }}
          css={css`
            border-radius: ${theme.shape.borderRadius[0]};
            box-shadow: ${theme.elevation.level2};
          `}
          placeholder="blurred"
          width={450}
          src="../../images/index_material_flow_insulation.jpg"
          alt=""
        />
      }
    />
  )
}

export default MaterialFlow
